module.exports = __webpack_public_path__ + "static/media/residence-card-back-sample.4bd7d087.svg";